<template>
  <div class="car-brands" :class="{'car-brands--mobile': deviceType === 'mobile'}">
    <div class="car-brands__container">
      <div class="car-brands__header">
        <h2 class="car-brands__title">Browse by Brands</h2>
        <a class="car-brands__view-more" :href="getHrefForAll()">
          <span>View More</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="10" viewBox="0 0 24 10"
            fill="none">
            <path
              d="M19.6112 10H16.3112C16.0733 10 15.9535 9.66313 16.1219 9.46625L19.9432 5L16.1214 0.533125C15.9529 0.336875 16.0727 0 16.3107 0H19.6106C19.8235 0 20.0272 0.0987495 20.178 0.274374L23.8432 4.55812C24.0523 4.8025 24.0523 5.19813 23.8432 5.44188L20.1785 9.725C20.0277 9.90125 19.824 10 19.6112 10ZM4.13548 9.725L7.80012 5.44188C8.00921 5.1975 8.00921 4.80187 7.80012 4.55812L4.13494 0.274374C3.98468 0.0987495 3.78094 0 3.56811 0H0.268158C0.0301937 0 -0.0895905 0.336875 0.078856 0.53375L3.90019 5L0.078856 9.46625C-0.0895905 9.66313 0.0296589 10 0.268158 10H3.56811C3.78094 10 3.98521 9.90125 4.13548 9.725ZM12.1567 9.725L15.8214 5.44188C16.0305 5.1975 16.0305 4.80187 15.8214 4.55812L12.1562 0.274374C12.0065 0.0987495 11.8022 0 11.5894 0H8.28942C8.05146 0 7.93167 0.336875 8.10012 0.53375L11.922 5L8.10065 9.46625C7.93221 9.66313 8.05146 10 8.28942 10H11.5894C11.8027 10 12.0065 9.90125 12.1567 9.725Z"
              fill="#e2372d" />
          </svg>
        </a>
      </div>
      <div class="car-brands__grid">
        <a v-for="(brand, index) in carBrands" :key="index" class="car-brands__card"
          :href="getHrefForBrand(brand.value)">
          <div class="car-brands__card-inner">
            <img :src="brand.logo" class="car-brands__logo-img" :alt="brand.name">
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'CarBrands',
  data () {
    return {
      carBrands: [
        { name: 'Toyota', value: 'Toyota', logo: require('@/assets/brands/toyota.png') },
        { name: 'Ford', value: 'Ford', logo: require('@/assets/brands/ford.png') },
        { name: 'Audi', value: 'Audi', logo: require('@/assets/brands/audi.png') },
        { name: 'Hyundai', value: 'Hyundai', logo: require('@/assets/brands/hyundai.png') },
        { name: 'BMW', value: 'BMW', logo: require('@/assets/brands/bmw.png') },
        { name: 'Chevrolet', value: 'Chevrolet', logo: require('@/assets/brands/chevrolet.png') },
        { name: 'Volkswagen', value: 'Volkswagen', logo: require('@/assets/brands/volkswagen.png') },
        { name: 'Mercedes-Benz', value: 'Mercedes-Benz', logo: require('@/assets/brands/mercedes.png') }
      ]
    };
  },
  computed: { ...mapGetters(['deviceType']) },
  methods: {
    getHrefForAll () { return this.$route.params.channel ? `/${this.$route.params.channel}/car-list` : '/car-list'; },
    getHrefForBrand (brand) {
      const query = `?brand=${encodeURIComponent(brand)}`;
      return this.$route.params.channel ? `/${this.$route.params.channel}/car-list${query}` : `/car-list${query}`;
    }
  }
};
</script>

<style lang="scss">
@import '~@/css/variables.scss';
.car-brands {
	background: #000;
	padding: rem(60) rem(180);
	width: 100%;
	box-sizing: border-box;
	&__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: rem(30);
	}
	&__title {
		color: #ffffff;
		font-family: 'Inter-ExtraBold', sans-serif;
		font-size: rem(24);
		font-weight: 800;
		margin: 0;
	}
	&__view-more {
		display: flex;
		align-items: center;
		gap: rem(12);
		text-decoration: none;
		span {
			color: #e2372d;
			font-family: 'Inter-ExtraBold', sans-serif;
			font-size: rem(14);
			font-weight: 800;
		}
	}
	&__grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: rem(20);
	}
	&__card {
		background: linear-gradient(180deg, rgba(226, 55, 45, 0) 0%, rgba(226, 55, 45, 0.2) 100%);
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.1);
		height: rem(124);
		display: flex;
		align-items: center;
		justify-content: center;
		text-decoration: none;
		transition: all 0.3s ease;
		&:hover {
			transform: translateY(-5px);
			border-color: rgba(226, 55, 45, 0.5);
		}
	}
	&__card-inner {
		width: 100%;
		height: 100%;
		background: linear-gradient(-90deg, rgba(255, 255, 255, 0) 0%, #ffffff 40%, #ffffff 60%, rgba(153, 153, 153, 0) 100%);
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: rem(16);
	}
	&__logo-img {
		max-width: 60%;
		max-height: 60%;
		object-fit: contain;
	}
}
.detect_deviece_mobile {
	.car-brands {
		padding: rem(60) 0 rem(60) rem(16);
		&__header {
			padding-right: rem(16);
		}
		&__grid {
			display: flex;
			gap: rem(12);
			padding-right: rem(20);
      flex-wrap: wrap;
			&::-webkit-scrollbar {
				display: none;
			}
		}
		&__card {
			flex-shrink: 0;
      flex-basis: calc(50% - rem(6));
      padding: rem(8)
		}
	}
}
</style>